import { getMessage } from '@locaweb/design-system-vue'
import {
  registerIcon,
  placesHomeOutline,
  localizationGlobeOutline,
  objectsMailOutline
} from '@locaweb/design-system-icons'

export default () => {
  registerIcon(
    placesHomeOutline,
    localizationGlobeOutline,
    objectsMailOutline
  )

  return [
    {
      title: getMessage('sidebarMenu.homePage'),
      icon: '$places-home-outline',
      link: { name: 'siteWelcome' },
      exactPath: true
    },
    {
      title: getMessage('sidebarMenu.site.title'),
      icon: '$localization-globe-outline',
      childs: [
        {
          title: getMessage('sidebarMenu.site.editSite'),
          link: { name: 'editorView' },
          exactPath: false
        },
        {
          title: getMessage('sidebarMenu.site.manageDomain'),
          link: { name: 'manageDomain' },
          exactPath: false
        },
        {
          title: getMessage('sidebarMenu.site.manageFavicon'),
          link: { name: 'manageFavicon' },
          exactPath: false
        }
      ]
    },
    {
      title: getMessage('sidebarMenu.email'),
      icon: '$objects-mail-outline',
      link: process.env.VUE_APP_EMAIL_PANEL_URL,
      external: true,
      exactPath: false
    }
  ]
}
